import axiosInstance from 'src/utils/axios';
import {
  CreateUpdateToAnnualSaasSubscriptionLink,
  Subscription,
  SubscriptionPlansResponse,
  SubscriptionsResponse,
} from './types.api';

//
//

export const SAAS_SUBSCRIPTIONS_API = '/subscriptions/v1/merchant-saas';

//

export const getSubscriptionsAPI = async (merchantCode: string): Promise<SubscriptionsResponse> => {
  const response = await axiosInstance.get<SubscriptionsResponse>(
    `${SAAS_SUBSCRIPTIONS_API}/${merchantCode}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const startTrialAPI = async (merchantCode: string, trialSubscription: Subscription) => {
  const response = await axiosInstance.post(
    `${SAAS_SUBSCRIPTIONS_API}/${merchantCode}/start-trial`,
    trialSubscription
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response;
};

export const getSubscriptionPlansAPI = async (): Promise<SubscriptionPlansResponse> => {
  const response = await axiosInstance.get<SubscriptionPlansResponse>(
    `${SAAS_SUBSCRIPTIONS_API}/plans`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const createUpdateToAnnualSaasSubscriptionLinkAPI = async (
  merchantCode: string,
  data: CreateUpdateToAnnualSaasSubscriptionLink
) => {
  return axiosInstance.post(
    `${SAAS_SUBSCRIPTIONS_API}/update-confirm-flow/${merchantCode}`,
    JSON.stringify(data)
  );
};

export const cancelSubscriptionAPI = async (merchantCode: string, data: any) => {
  return axiosInstance.post(
    `${SAAS_SUBSCRIPTIONS_API}/cancel-flow/${merchantCode}`,
    JSON.stringify(data)
  );
};

export const updatePaymentMethodAPI = async (merchantCode: string, data: any) => {
  return axiosInstance.post(
    `${SAAS_SUBSCRIPTIONS_API}/update-payment-method-flow/${merchantCode}`,
    JSON.stringify(data)
  );
};
